import * as React from 'react';

import { useOffersHistoryContext } from '../../context';
import { TCategoriesFilterOptionValue, TRoomsFilterOptionValue, TStatusFilterOptionValue } from '../../types';
import { Filter, Filters } from '../../components/Desktop';

/**
 * Контейнер собирает блок фильтров
 *   * фильтр расположения
 *   * фильтры статусов
 *   * фильтры комнат
 *   * фильтры категории
 * Если по какому-то отдельному фильтру данных нет - он не будет отрендерен
 * */
export const FiltersContainer: React.FC = () => {
  const {
    statusFilterActiveValue,
    roomsFilterActiveValue,
    categoriesFilterActiveValue,
    data: {
      listing: { data },
    },
    onCategoriesFilterChange,
    onRoomsFilterChange,
    onStatusFilterChange,
  } = useOffersHistoryContext();

  const statusFilters = data?.statusFilters ?? null;
  const roomsFilters = data?.roomsFilters ?? null;
  const categoriesFilters = data?.categoriesFilters ?? null;

  return (
    <Filters>
      {statusFilters && (
        <Filter
          title="Статус объявления"
          spliced={false}
          options={statusFilters}
          value={statusFilterActiveValue}
          dataName="StatusFilter"
          onChange={(_, value) => onStatusFilterChange(value as TStatusFilterOptionValue)}
        />
      )}
      {roomsFilters && (
        <Filter
          title="Количество комнат"
          spliced={false}
          options={roomsFilters}
          value={roomsFilterActiveValue}
          dataName="RoomsCountFilter"
          onChange={(_, value) => onRoomsFilterChange(value as TRoomsFilterOptionValue)}
        />
      )}
      {categoriesFilters && (
        <Filter
          title="Тип объявления"
          spliced={false}
          options={categoriesFilters}
          value={categoriesFilterActiveValue}
          dataName="CategoryFilter"
          onChange={(_, value) => onCategoriesFilterChange(value as TCategoriesFilterOptionValue)}
        />
      )}
    </Filters>
  );
};
